import angular from 'angular';
import DoctorOrConditionSelectorComponent from './doctor-or-condition-selector.component';
import FrAutocompleteComponent from '../../common/autocomplete/autocomplete.component';
import HighlightFilter from '../../common/filters/highlight.filter';

let address = angular
	.module('doctorOrConditionSelector', [])
	.filter('highlight', HighlightFilter)
	.component('frAutocomplete', FrAutocompleteComponent)	
	.component('doctorOrConditionSelector', DoctorOrConditionSelectorComponent)
	.name;

export default address;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-or-condition-selector/doctor-or-condition-selector.module.js